import { Toaster as Sonner } from "sonner"
import { X } from "lucide-react"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      position="bottom-right"
      closeButton={true}
      icons={{
        close: <X className="h-4 w-4" />,
      }}
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton: "group-[.toast]:bg-card group-[.toast]:text-foreground group-[.toast]:border-border hover:group-[.toast]:bg-accent",
          success: "!bg-green-950/30 !text-green-300 !border-green-800/50 [&>[data-description]]:!text-green-400/80",
          error: "!bg-red-950/30 !text-red-300 !border-red-800/50 [&>[data-description]]:!text-red-400/80",
          warning: "!bg-yellow-950/30 !text-yellow-300 !border-yellow-800/50 [&>[data-description]]:!text-yellow-400/80",
          info: "!bg-blue-950/30 !text-blue-300 !border-blue-800/50 [&>[data-description]]:!text-blue-400/80"
        }
      }}
      style={
        {
          "--normal-bg": "var(--card)",
          "--normal-text": "var(--foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
